import React, { useEffect, useMemo, useState } from "react";
import Tile from "./Tile";
import { TileType } from "../types";

function getMaxPerTile(screenWidth: number, gridSize: number) {
  // breakpoints: <=1750, 1750<width<1920, 1920<=width<2300, >=2300

  if (screenWidth <= 1780) {
    // original small-screen values
    if (gridSize > 6) return 82;
    if (gridSize > 5) return 110;
    if (gridSize > 4) return 135;
    return 180;
  }

  if (screenWidth < 1920) {
    // medium: keep previous >1750 behavior
    if (gridSize > 6) return 105;
    if (gridSize > 4) return 120;
    return 170;
  }

  if (screenWidth < 2300) {
    // large screens (>=1920 and <2300) - slightly larger card sizes
    if (gridSize > 6) return 90;
    if (gridSize > 4) return 115;
    return 170;
  }

  // extra large screens (>=2300)
  if (gridSize > 6) return 500;
  if (gridSize > 4) return 140;
  return 200;
}

export default function GameBoard({
  tiles,
  clickTile,
  gridSize,
  isGameOver,
}: {
  tiles: TileType[];
  gridSize: number;
  clickTile: (id: number) => void;
  isGameOver: boolean;
}) {
  const [screenWidth, setScreenWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1024
  );

  useEffect(() => {
    const onResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const maxWidth = useMemo(
    () => Math.min(gridSize * getMaxPerTile(screenWidth, gridSize), 900),
    [screenWidth, gridSize]
  );

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: `repeat(${gridSize}, 1fr)`,
        gap: "8px",
        width: "100%",
        maxWidth: `${maxWidth}px`,
        margin: "0 auto",
      }}
    >
      {tiles.map((t) => (
        <Tile
          key={t.id}
          tile={t}
          isGameOver={isGameOver}
          onClick={(id) => !isGameOver && clickTile(id)}
          gridSize={gridSize}
        />
      ))}
    </div>
  );
}
